export default __webpack_public_path__ + "static/media/img1.1f746a30.webp";